import { useState } from 'react';
import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';
import { Status as ClientStatus } from 'store/clients/clientsSlice';
import { useAppSelector } from 'store/hooks';

import { NoteForm } from '../NoteForm';
import { PopupDraftNoteFormProvider } from '../context';
import { AiScribeMedia, NoteBodyFields, NoteFields, PopupDraftActions } from './NoteFormSections';

type PopupNoteFormProps = {
  status: ClientStatus | ClientStatus['id'];
  clientId: string;
  note?: ClientProfileContentItem;
  disabled?: boolean;
};

const PopupNoteFormContent = ({ onEdit }: { onEdit?: () => void }) => {
  return (
    <NoteForm.Form>
      <NoteFields expanded includeMpiEntry />
      <AiScribeMedia />
      <NoteBodyFields hideNoteWhenMpi />
      <PopupDraftActions onEdit={onEdit} />
    </NoteForm.Form>
  );
};

/**
 * Preset component for editing notes in a popup.
 * Disabled state is controlled from outside via props.
 * Includes AI Scribe status, transcript, and audio player.
 * Autosave is enabled only for draft notes.
 */
export const PopupNoteForm = ({ status, clientId, note, disabled = true }: PopupNoteFormProps) => {
  const { data } = useAppSelector((state) => state.clients.client);
  const [isEditing, setIsEditing] = useState(!disabled);
  const onEdit = () => {
    setIsEditing(true);
  };

  return (
    <PopupDraftNoteFormProvider
      status={status}
      clientId={clientId}
      note={note}
      disabled={!isEditing}
      clientName={data?.firstName + ' ' + data?.lastName ?? ''}
      prependedClientId={data?.prependedId ?? ''}
    >
      <NoteForm.Root>
        <PopupNoteFormContent onEdit={onEdit} />
      </NoteForm.Root>
    </PopupDraftNoteFormProvider>
  );
};
